import {useMutation} from "@tanstack/react-query";
import {createExpedientMutationOptions} from "./create-expedient.mutation-options";

export function useCreateExpedient() {
  return useMutation(createExpedientMutationOptions());
}
